// removed by extract-text-webpack-plugin
module.exports = {"tileContainer":"tileContainer__1PCP_","imageContainer":"imageContainer__Bu9tN","categoryTitle":"categoryTitle__3GqL8","categoryImgContainer":"categoryImgContainer__i0NW8","categoryImg":"categoryImg__2-i31","filterImage":"filterImage__ZuafM","imageTile":"imageTile__2Vsz7","tileDescription":"tileDescription__1S0CX","tileDescriptionContent":"tileDescriptionContent__5H7T_","allCategoryTileTitle":"allCategoryTileTitle__35oYP","allCategoryImg":"allCategoryImg__UvEVQ"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/category/style.css
// module id = /lUK
// module chunks = 323